var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx, jsxs } from "react/jsx-runtime";
import { startTransition, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { theme, Select, Radio, Avatar, Space, Flex, Grid } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import {
  ArrowDown,
  SearchIcon,
  TabsScrollWrapper
} from "@inscore/shared";
import StatsApi from "./../../../api/StatsApi.js";
import OptionRender from "./optionRender/OptionRender";
import "./searchLeagues.css";
const { useBreakpoint } = Grid;
const SearchLeagues = ({
  searchedLeague,
  chosenLeague,
  handleSearchedLeague,
  handleChosenLeague,
  renderNewVersion = true
}) => {
  const searchApi = StatsApi.searchSpecialStatsLeagues();
  const selectRef = useRef(null);
  const initialLeaguesLoaded = useRef(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { token } = theme.useToken();
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [query, setQuery] = useState("");
  const [data, setData] = useState([]);
  const [leagues, setLeagues] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    search({ query });
    return () => {
      searchApi.cancel();
    };
  }, [query]);
  useEffect(() => {
    if (leagues.length && !searchedLeague && !chosenLeague) {
      if (searchParams.get("l")) {
        const found = leagues.find(
          (league) => league.id === +searchParams.get("l")
        );
        if (found) {
          handleChosenLeague(found);
        } else {
          handleChosenLeague(leagues[0]);
          setSearchParams({ l: leagues[0].id });
        }
      } else {
        handleChosenLeague(leagues[0]);
        setSearchParams({ l: leagues[0].id });
      }
    }
  }, [leagues.length, searchedLeague, chosenLeague]);
  const handleSearch = (value) => {
    startTransition(() => setQuery(value));
  };
  const search = async (params) => {
    var _a, _b;
    try {
      const response = await searchApi.call(params);
      setData((_a = response.data.Competitions) != null ? _a : []);
      if (!initialLeaguesLoaded.current) {
        initialLeaguesLoaded.current = true;
        setLeagues((_b = response.data.Competitions) != null ? _b : []);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const onLeagueSelect = (_, option) => {
    var _a;
    handleSearchedLeague(option);
    (_a = selectRef.current) == null ? void 0 : _a.blur();
    setSearchParams({ l: option.id });
  };
  const onLeagueChoose = (e) => {
    handleChosenLeague(
      leagues.find((league) => league.id === e.target.value)
    );
    setSearchParams({ l: e.target.value });
  };
  const onClear = () => {
    var _a;
    setQuery("");
    handleChosenLeague(leagues[0]);
    (_a = selectRef.current) == null ? void 0 : _a.blur();
  };
  return /* @__PURE__ */ jsxs(
    Flex,
    {
      vertical: true,
      gap: 16,
      className: "search-leagues",
      style: renderNewVersion || isMobile ? { minWidth: 0, width: "100%" } : { minWidth: "50%", width: "max-content" },
      children: [
        !renderNewVersion && !isMobile && /* @__PURE__ */ jsx(
          Select,
          {
            value: searchedLeague == null ? void 0 : searchedLeague.id,
            showSearch: true,
            ref: selectRef,
            loading,
            onClear,
            filterOption: false,
            onSearch: handleSearch,
            onSelect: onLeagueSelect,
            prefix: /* @__PURE__ */ jsx(SearchIcon, { className: "stroke-base" }),
            options: data.map((l) => __spreadProps(__spreadValues({}, l), { value: l.id })),
            allowClear: {
              clearIcon: /* @__PURE__ */ jsx(
                CloseOutlined,
                {
                  style: { color: token.colorTextBase }
                }
              )
            },
            labelRender: ({ value }) => value && searchedLeague ? /* @__PURE__ */ jsx(
              OptionRender,
              {
                option: searchedLeague,
                token,
                inLabel: true
              }
            ) : "",
            optionRender: (option) => /* @__PURE__ */ jsx(OptionRender, { option: option.data, token })
          }
        ),
        renderNewVersion || isMobile ? /* @__PURE__ */ jsx(
          Select,
          {
            value: chosenLeague == null ? void 0 : chosenLeague.id,
            onChange: (value) => {
              const league = leagues.find((l) => l.id === value);
              handleChosenLeague(league);
              setSearchParams({ l: value });
            },
            options: leagues.map((l) => ({
              label: /* @__PURE__ */ jsx(OptionRender, { option: l, token }),
              value: l.id
            })),
            labelRender: () => chosenLeague ? /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 8, children: [
              /* @__PURE__ */ jsx(
                Avatar,
                {
                  src: chosenLeague.iconUrl,
                  size: isMobile ? 18 : 22,
                  style: {
                    flexShrink: 0,
                    backgroundColor: token.colorWhite
                  }
                }
              ),
              /* @__PURE__ */ jsx("span", { className: "truncate-line", children: chosenLeague.name })
            ] }) : "",
            suffixIcon: /* @__PURE__ */ jsx(
              ArrowDown,
              {
                className: "stroke-base",
                style: { width: 20, height: 20 }
              }
            ),
            className: "stats-select",
            popupMatchSelectWidth: false,
            style: { width: "100%" },
            placeholder: leagues.length ? void 0 : "",
            disabled: leagues.length === 0
          }
        ) : /* @__PURE__ */ jsx(TabsScrollWrapper, { children: /* @__PURE__ */ jsx(
          Radio.Group,
          {
            buttonStyle: "solid",
            value: chosenLeague == null ? void 0 : chosenLeague.id,
            onChange: onLeagueChoose,
            className: "radio-group-secondary",
            children: leagues.map((item) => /* @__PURE__ */ jsx(Radio.Button, { value: item.id, children: /* @__PURE__ */ jsxs(Space, { size: 12, children: [
              item.iconUrl && /* @__PURE__ */ jsx(
                Avatar,
                {
                  size: "small",
                  src: item.iconUrl,
                  style: {
                    borderRadius: "50%",
                    flexShrink: 0,
                    backgroundColor: token.colorWhite
                  }
                }
              ),
              item.name
            ] }) }, item.id))
          }
        ) })
      ]
    }
  );
};
var stdin_default = SearchLeagues;
export {
  stdin_default as default
};
